// // import { Swiper, SwiperSlide } from "swiper/react";
// // import { useEffect, useState, useRef } from "react";
// // import styles from "./ServicesSection.module.scss";
// // import "swiper/css";
// // import HomeServices from "../../../../pages/home/homeService/HomeService";
// // import { useSelector } from "react-redux";
// // import { RootState } from "../../../../redux/store";
// // import { Autoplay } from "swiper/modules";

// // interface ServiceSlide {
// //   id: number;
// //   name: string;
// //   logo: string;
// // }

// // interface Partner {
// //   id: number;
// //   name: string;
// //   logo: string;
// // }

// // const ServicesSection = () => {
// //   const [activeIndexes, setActiveIndexes] = useState<number[]>([]);
// //   const [allPartners, setAllPartners] = useState<Partner[]>([]);
// //   const translations = useSelector(
// //     (state: RootState) => state.translations.data
// //   );
// //   const swiperRef = useRef<any>(null);

// //   const handleSlideChange = (swiper: any) => {
// //     const slidesToShow = Math.floor(swiper.params.slidesPerView);

// //     let activeCount = 1;
// //     if (slidesToShow >= 6) activeCount = 4;
// //     else if (slidesToShow >= 4) activeCount = 2;
// //     else if (slidesToShow === 3) activeCount = 2;
// //     else activeCount = 1;

// //     const start =
// //       swiper.activeIndex + Math.floor((slidesToShow - activeCount) / 2);
// //     const newActiveIndexes: number[] = [];

// //     for (let i = 0; i < activeCount; i++) {
// //       const realIndex =
// //         swiper.slides[(start + i) % swiper.slides.length]?.dataset
// //           ?.swiperSlideIndex;
// //       if (realIndex !== undefined) {
// //         newActiveIndexes.push(Number(realIndex));
// //       }
// //     }

// //     setActiveIndexes(newActiveIndexes);
// //   };

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const res = await HomeServices.getPartnors();
// //         const partners = res.services;

// //         const minSlidesForLoop = 7;
// //         const extendedPartners =
// //           partners.length < minSlidesForLoop
// //             ? [...partners, ...partners].slice(0, minSlidesForLoop)
// //             : partners;

// //         setAllPartners(extendedPartners);
// //         setActiveIndexes([1, 2, 3, 4]);
// //       } catch (error) {
// //         console.log(error, " data error");
// //       }
// //     };

// //     fetchData();
// //   }, []);

// //   return (
// //     <section id={styles.services_section}>
// //       <div className={styles.services_section}>
// //         <div className="container">
// //           <div className={styles.section_head}>
// //             <h1 className={styles.title}>{translations.service_center}</h1>
// //           </div>
// //         </div>
// //         <div className={styles.services_slider}>
// //           <div className="containersss">
// //             <Swiper
// //               slidesPerView={6}
// //               className={styles.mySwiper}
// //               onSlideChange={handleSlideChange}
// //               onSwiper={(swiper: any) => {
// //                 swiperRef.current = swiper;
// //                 handleSlideChange(swiper);
// //               }}
// //               loop={true}
// //               autoplay={{ delay: 1500, disableOnInteraction: false }}
// //               modules={[Autoplay]}
// //               breakpoints={{
// //                 0: { slidesPerView: 1 },
// //                 400: { slidesPerView: 2 },
// //                 576: { slidesPerView: 2 },
// //                 768: { slidesPerView: 3 },
// //                 993: { slidesPerView: 3 },
// //                 1024: { slidesPerView: 4 },
// //                 1280: { slidesPerView: 6 },
// //               }}
// //             >
// //               {allPartners.map((slide: ServiceSlide, idx: number) => {
// //                 const isActive = activeIndexes.includes(idx);
// //                 return (
// //                   <SwiperSlide
// //                     key={`service-${idx}-${slide.id}`}
// //                     className={isActive ? styles.active_slide : styles.slide}
// //                     data-swiper-slide-index={idx} // bu vacibdir
// //                   >
// //                     <img src={slide.logo} alt={slide.name} />
// //                   </SwiperSlide>
// //                 );
// //               })}
// //             </Swiper>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default ServicesSection;

// import { Swiper, SwiperSlide } from "swiper/react";
// import { useState, useRef } from "react";
// import styles from "./ServicesSection.module.scss";
// import "swiper/css";
// import { useSelector } from "react-redux";
// import { RootState } from "../../../../redux/store";
// import { Autoplay } from "swiper/modules";
// import { useOfficialServices } from "../../../../hooks/useHomeQueries";

// interface ServiceSlide {
//   id: number;
//   name: string;
//   logo: string;
// }

// interface Partner {
//   id: number;
//   name: string;
//   logo: string;
// }

// const ServicesSection = () => {
//   const [activeIndexes, setActiveIndexes] = useState<number[]>([]);
//   const translations = useSelector(
//     (state: RootState) => state.translations.data
//   );
//   const swiperRef = useRef<any>(null);
//   const theme = useSelector((state: RootState) => state.theme.mode);

//   const { data: officialServicesResponse, isLoading: loading } = useOfficialServices();
//   const partners = officialServicesResponse?.services || [];
//   console.log(partners);
  
//   const minSlidesForLoop = 6;
//   const allPartners =
//     partners.length < minSlidesForLoop
//       ? [...partners, ...partners].slice(0, minSlidesForLoop)
//       : partners;
//   // console.log(allPartners);
  
//   const handleSlideChange = (swiper: any) => {
//     if (!allPartners.length) return; // data gəlməyibsə işlətmə

//     const slidesToShow = Math.floor(swiper.params.slidesPerView);

//     let activeCount = 1;
//     if (slidesToShow >= 6) activeCount = 4;
//     else if (slidesToShow >= 4) activeCount = 2;
//     else if (slidesToShow === 3) activeCount = 2;

//     const start = swiper.realIndex; // ✅ həmişə doğru index
//     const newActiveIndexes: number[] = [];

//     for (let i = 0; i < activeCount; i++) {
//       newActiveIndexes.push((start + i) % allPartners.length);
//     }

//     setActiveIndexes(newActiveIndexes);
//   };

//   return (
//     <section id={styles.services_section}>
//       <div className={styles.services_section}>
//         <div className="container">
//           <div className={styles.section_head}>
//             {loading ? (
//               <div className={styles.skeletonTitle}></div>
//             ) : (
//               <h1
//                 className={theme === "light" ? styles.title : styles.title_dark}
//               >
//                 {translations.service_center}
//               </h1>
//             )}
//           </div>
//         </div>
//         <div className={styles.services_slider}>
//           <div className="containersss">
//             {loading ? (
//               <Swiper
//                 loop={false}
//                 autoplay={false}
//                 slidesPerView={6}
//                 className={styles.mySwiper}
//                 modules={[Autoplay]}
//                 breakpoints={{
//                   0: { slidesPerView: 1 },
//                   400: { slidesPerView: 2 },
//                   576: { slidesPerView: 2 },
//                   768: { slidesPerView: 3 },
//                   993: { slidesPerView: 3 },
//                   1024: { slidesPerView: 4 },
//                   1280: { slidesPerView: 6 },
//                 }}
//               >
//                 {Array(6)
//                   .fill(0)
//                   .map((_, idx) => (
//                     <SwiperSlide key={idx} className={styles.slide}>
//                       <div className={styles.skeletonSlide}></div>
//                     </SwiperSlide>
//                   ))}
//               </Swiper>
//             ) : (
//               <Swiper
//                 key={allPartners.length} // allPartners dəyişəndə swiper reset olsun
//                 loop={true}
//                 autoplay={{ delay: 1500, disableOnInteraction: false }}
//                 slidesPerView={6}
//                 className={styles.mySwiper}
//                 onSlideChangeTransitionEnd={handleSlideChange} // ✅ transition bitəndə
//                 onSwiper={(swiper: any) => {
//                   swiperRef.current = swiper;
//                 }}
//                 modules={[Autoplay]}
//                 breakpoints={{
//                   0: { slidesPerView: 1 },
//                   400: { slidesPerView: 2 },
//                   576: { slidesPerView: 2 },
//                   768: { slidesPerView: 3 },
//                   993: { slidesPerView: 3 },
//                   1024: { slidesPerView: 4 },
//                   1280: { slidesPerView: 6 },
//                 }}
//               >
//                 {allPartners.map((slide: ServiceSlide, idx: number) => {
//                   const isActive = activeIndexes.includes(idx);
//                   return (
//                     <SwiperSlide
//                       key={`service-${idx}-${slide.id}`}
//                       className={isActive ? styles.active_slide : styles.slide}
//                     >
//                       <img src={slide.logo} alt={slide.name} width="200" height="200" />
//                     </SwiperSlide>
//                   );
//                 })}
//               </Swiper>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ServicesSection;


import { Swiper, SwiperSlide } from "swiper/react";
import { useState, useRef, useEffect } from "react";
import styles from "./ServicesSection.module.scss";
import "swiper/css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Autoplay } from "swiper/modules";
import { useOfficialServices } from "../../../../hooks/useHomeQueries";

interface ServiceSlide {
  id: number;
  name: string;
  logo: string;
}

const ServicesSection = () => {
  const [activeIndexes, setActiveIndexes] = useState<number[]>([]);
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );
  const swiperRef = useRef<any>(null);
  const theme = useSelector((state: RootState) => state.theme.mode);

  const { data: officialServicesResponse, isLoading: loading } = useOfficialServices();
  const partners = officialServicesResponse?.services || [];

  // Swiper loop-un düzgün fırlanması üçün data sayı slidesPerView-dan çox olmalıdır.
  // 6 datan varsa, onu 12 edirik ki, sürüşmə zamanı boşluq yaranmasın.
  const allPartners =
    partners.length > 0 && partners.length <= 6
      ? [...partners, ...partners]
      : partners;

  const handleSlideChange = (swiper: any) => {
    if (!allPartners.length) return;

    const slidesToShow = Math.floor(swiper.params.slidesPerView);

    let activeCount = 1;
    if (slidesToShow >= 6) activeCount = 4;
    else if (slidesToShow >= 4) activeCount = 2;
    else if (slidesToShow === 3) activeCount = 2;

    // Loop rejimində swiper.realIndex həqiqi məlumatın indeksini verir (0, 1, 2...)
    const start = swiper.realIndex;
    const newActiveIndexes: number[] = [];

    for (let i = 0; i < activeCount; i++) {
      newActiveIndexes.push((start + i) % allPartners.length);
    }

    setActiveIndexes(newActiveIndexes);
  };

  // İlk data yüklənəndə aktiv indeksləri təyin etmək üçün
  useEffect(() => {
    if (allPartners.length > 0 && swiperRef.current) {
      handleSlideChange(swiperRef.current);
    }
  }, [allPartners.length]);

  return (
    <section id={styles.services_section}>
      <div className={styles.services_section}>
        <div className="container">
          <div className={styles.section_head}>
            {loading ? (
              <div className={styles.skeletonTitle}></div>
            ) : (
              <h1
                className={theme === "light" ? styles.title : styles.title_dark}
              >
                {translations.service_center}
              </h1>
            )}
          </div>
        </div>
        <div className={styles.services_slider}>
          <div className="containersss">
            {loading ? (
              <Swiper
                loop={false}
                autoplay={false}
                slidesPerView={6}
                className={styles.mySwiper}
                modules={[Autoplay]}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  400: { slidesPerView: 2 },
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  993: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1280: { slidesPerView: 6 },
                }}
              >
                {Array(6)
                  .fill(0)
                  .map((_, idx) => (
                    <SwiperSlide key={idx} className={styles.slide}>
                      <div className={styles.skeletonSlide}></div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            ) : (
              <Swiper
                key={allPartners.length}
                loop={allPartners.length > 0}
                autoplay={{ delay: 1500, disableOnInteraction: false }}
                slidesPerView={6}
                className={styles.mySwiper}
                // onSlideChangeTransitionEnd yerinə onSlideChange daha axıcıdır
                onSlideChange={handleSlideChange}
                onSwiper={(swiper: any) => {
                  swiperRef.current = swiper;
                  // Swiper hazır olan kimi rəngləri hesabla
                  setTimeout(() => handleSlideChange(swiper), 100);
                }}
                modules={[Autoplay]}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  400: { slidesPerView: 2 },
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  993: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1280: { slidesPerView: 6 },
                }}
              >
                {allPartners.map((slide: ServiceSlide, idx: number) => {
                  const isActive = activeIndexes.includes(idx);
                  return (
                    <SwiperSlide
                      key={`service-${idx}-${slide.id}`}
                      className={isActive ? styles.active_slide : styles.slide}
                    >
                      <img src={slide.logo} alt={slide.name} width="200" height="200" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;